<div class="dialog-container">
  <div class="dialog-header">
    <img src="assets/img/icons/challenge-builder/salvages.png" alt="Salvage" class="header-icon" />
    <h2 class="header-title">Plot twist!</h2>
    <p class="header-description">
      Your cycle is at risk but you can <br />
      still save it.
    </p>
  </div>

  <div class="task-list">
    @for (task of data.tasks; track task._id) {
      <button
        class="task-cell"
        [class.selected]="selectedTaskId() === task._id"
        (click)="onTaskClick(task)"
        [disabled]="selectedTaskId() !== null && selectedTaskId() !== task._id"
      >
        @if (selectedTaskId() === task._id) {
          <div class="check-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 13l4 4L19 7"
                stroke="#7bc143"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        } @else {
          <img [src]="'assets/img/icons/color-icons/' + task.icon + '.svg'" [alt]="task.label" class="task-icon" />
          <span class="task-label">{{ task.label }}</span>
        }
      </button>
    }
  </div>

  <div class="dialog-footer">
    <button class="not-today-button" (click)="onNotToday()">Not Today</button>
  </div>
</div>
